import React from 'react'
import { Trans, useTranslation, withI18nContext } from '@mc/i18n'
import { BogoTermsLink } from '../../featureVariables'
import { BOGO_I18N_NAMESPACE, i18nInstance } from '../../i18n'

const PromotionNonAppliedErrorMessageComp = () => {
  const { t } = useTranslation(BOGO_I18N_NAMESPACE)
  return (
    <>
      <Trans i18nKey={'discountModal.error.message'} ns={BOGO_I18N_NAMESPACE}>
        <span className='mc-text--bold' />
      </Trans>{' '}
      <BogoTermsLink textFixed={t('discountModal.error.terms')} />
    </>
  )
}

export const PromotionNonAppliedErrorMessage = withI18nContext(i18nInstance)(
  PromotionNonAppliedErrorMessageComp,
)
